// extracted by mini-css-extract-plugin
export default {"notFound":"Notfound_notFound__pUQIw","notFound__img":"Notfound_notFound__img__rCGaY"};